import { type BookkeepingPendingActionSortField } from './BookkeepingManagerStore'

export type ColumnId =
  | 'JobId'
  | 'Customer'
  | 'JobName'
  | 'CompanyName'
  | 'Pro'
  | 'ProEmail'
  | 'AccessMethod'
  | 'Action'
  | 'TimeInAction'

export interface BookkeepingManagerColumnDetails {
  id: ColumnId
  header: string
  align: 'left' | 'right' | 'center'
  select: boolean
  sortable: boolean
  field?: BookkeepingPendingActionSortField
}

export const BookkeepingManagerTableColumns: BookkeepingManagerColumnDetails[] =
  [
    {
      id: 'JobId',
      header: 'Job ID',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'Customer',
      header: 'Customer',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'JobName',
      header: 'Job name',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'CompanyName',
      header: 'Company name',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'Pro',
      header: 'Pro',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'ProEmail',
      header: 'Pro email address',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'AccessMethod',
      header: 'Method',
      select: false,
      align: 'left',
      sortable: false,
    },
    {
      id: 'Action',
      header: 'Action',
      select: false,
      align: 'right',
      sortable: false,
    },
    {
      id: 'TimeInAction',
      header: 'Time in action',
      field: 'DatePendingSince',
      select: false,
      align: 'left',
      sortable: true,
    },
  ]
